module.exports = __webpack_public_path__ + "img/icon-pagination-arrow-right.85a01d31.svg";